import type { CSSProperties } from 'react';

/**
 * Las marcas chicas de un renglón de la hoja (✦ IA, 1 ref., ⚠ revisar, adicional, planta): TODAS con la
 * misma caja — misma altura, mismo borde, centradas en la línea — para que una al lado de la otra no
 * se vean desalineadas. Cada una pone solo su color.
 */
export function marcaDeRenglon(color: string, borde: string = color): CSSProperties {
  return {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 3,
    boxSizing: 'border-box',
    height: 16,
    padding: '0 5px',
    marginRight: 6,
    verticalAlign: 'middle',
    fontSize: 9.5,
    lineHeight: 1,
    fontWeight: 700,
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    borderRadius: 4,
    color,
    border: `1px solid ${borde}`,
  };
}
